import { Button, Checkbox, Form, Input } from 'antd';
import './App.css';
import '@ant-design/v5-patch-for-react-19'
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Message } from './components';
import { getEnterpriseInfo, logInFunction, messageGeneral } from './Functions';
import myImage from "./logo.jpeg"




function LogIn() {
  const navigate = useNavigate();
  const [openMessage, setOpenMessage] = useState(false);
  const [message, setMessage]         = useState('');
  const [context, start ]                         = messageGeneral();

  async function login (values) {
      try{
        const { username, password } = values;
        const log = await logInFunction(username, password);
        if(log){
          if( getEnterpriseInfo() != null ){
            navigate('/intro');
            return;
          }
          start('Errore login')
        }
        start('Errore login')
      }catch( err ){
        start('Errore login')
        console.log(err);
      }
    }

    useEffect(()=>{
      localStorage.clear();
    },[])

  return (
    <div className="center bg-color-primary all-viewport" style={{flexDirection:'column'}}>
      {context}
      {
        Message(message, openMessage, () => setOpenMessage(false) )
      }
      <div className='center' style={{width:'20%', marginBottom:'20px', backgroundColor:'white!important'}}><img style={{width:'70%'}} src={myImage} alt="Descrizione immagine" /></div>

      <Form
        name="basic"
        style={{ maxWidth: 600,}}
        onFinish={login}
        onFinishFailed={() => {}}
        autoComplete="off"
        className=''
      >  
        <div className='center text-style' style={{ marginBottom:'10px'}}> Accedi <span style={{fontSize:12, marginLeft:'10px'}} > v.1.0.6</span></div>
        <Form.Item
          name="username"
          rules={[{ required: true, message: 'Inserire Username' }]}
        >
          <Input className='input-style' placeholder='Email'/>
        </Form.Item>

        <Form.Item
          name="password"
          rules={[{ required: true, message: 'Inserire Password!' }]}
        >
          <Input.Password className='input-style' placeholder='Password'/>
        </Form.Item>

        {/* <Form.Item name="remember" valuePropName="checked" label={null}>
          <Checkbox>Remember me</Checkbox>
        </Form.Item> */}

        <div className='center' style={{flexDirection:'column'}}>
        <Button
            className='input-style color-one'
            type="primary" 
            htmlType="submit">
            Accedi </Button>

          <Button
          className='input-style color-two'
          onClick={()=> navigate('/register')} 
            style={{backgroundColor:'', marginTop:'20px'}} 
            type="primary">
            Registrati </Button>
        </div>
          

      </Form>
    </div>
  );
}

export default LogIn;
